import { Event } from 'types';
import { EventActions } from 'types/store/actions/events';
import { EventActionTypes } from 'types/store/actions/constants';
import Pagination from 'sources/sourceTypes/Pagination';

export const listSuccess = (payload: Pagination<Event>): EventActions => ({
  type: EventActionTypes.LIST_SUCCESS,
  payload,
});

export const listAllSuccess = (records: Array<Event>): EventActions => ({
  type: EventActionTypes.LIST_ALL_SUCCESS,
  payload: { records },
});

export const reset = (): EventActions => ({
  type: EventActionTypes.RESET,
});
